import { render, staticRenderFns } from "./game-total-rounds.vue?vue&type=template&id=32c771b9&scoped=true"
import script from "./game-total-rounds.vue?vue&type=script&lang=js"
export * from "./game-total-rounds.vue?vue&type=script&lang=js"
import style0 from "./game-total-rounds.vue?vue&type=style&index=0&id=32c771b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c771b9",
  null
  
)

export default component.exports